import {
  DefaultFavoritesConfig,
  DefaultFavoritesSubAccountsConfig,
  DefaultFavoriteStrategiesConfig,
  DefaultTabsStateConfig,
  DefaultWatchlistSettingsConfig,
  type BlotterTableStorageMap,
} from '@talos/kyoko';

import { DefaultBlottersConfig } from '@src/providers/BlottersContext';
import { DefaultDisplaySettingsConfig } from '@src/providers/DisplaySettingsProvider';
import type { IOrderPreset } from '@src/providers/OrderPresetsContext';
import { DefaultPortfolioSettingsConfig } from '@src/providers/PortfolioSettingContext';
import { DefaultSoundSettingsConfig } from '@src/providers/SoundProvider';
import { DefaultTradingSettingsConfig } from '@src/providers/TradingSettingsContext.types';
import { DefaultContextGuideConfig } from '@talos/kyoko';
import { DefaultMarketAccountsConfigValue } from '../../../../../packages/kyoko/src/contexts/DefaultMarketAccountsContext';
import { DefaultMarketSelectorConfig } from '../../components/MarketSelector/MarketSelectorConfigContext';
import { DefaultLayoutsConfig } from '../AppLayoutConfig/AppLayoutConfigContext';
import { DefaultAggregationConfig } from '../DefaultAggregationContext';
import { DefaultFavoriteAggregationsConfig } from '../FavoriteAggregationsContext';
import { DefaultOrderEntryConfig } from '../OrderEntryContext';
import { DefaultShowcasesConfig } from '../ShowcaseProvider/DefaultShowcasesConfig';

export const DEFAULT_APP_CONFIG = {
  recentSymbols: {},
  blotters3: {} as BlotterTableStorageMap,
  orderPresetsList: [] as IOrderPreset[],
  marketSelectorConfig: { ...DefaultMarketSelectorConfig },
  ...DefaultOrderEntryConfig,
  ...DefaultBlottersConfig,
  ...DefaultTabsStateConfig,
  ...DefaultDisplaySettingsConfig,
  ...DefaultTradingSettingsConfig,
  ...DefaultWatchlistSettingsConfig,
  ...DefaultSoundSettingsConfig,
  ...DefaultFavoritesConfig,
  ...DefaultPortfolioSettingsConfig,
  ...DefaultContextGuideConfig,
  ...DefaultLayoutsConfig,
  ...DefaultFavoriteAggregationsConfig,
  ...DefaultAggregationConfig,
  ...DefaultMarketAccountsConfigValue,
  ...DefaultFavoritesSubAccountsConfig,
  ...DefaultFavoriteStrategiesConfig,
  ...DefaultShowcasesConfig,
  /** Set by migrateBlotterTabsToPanelParams after blotter tabs are migrated into layout panel params. */
  blotterTabsMigrationVersion: undefined as number | undefined,
  /** Set by migrateRequiredPanels after formerly required blotter panels are restored on trading layouts. */
  requiredPanelsMigrationVersion: undefined as number | undefined,
  /** Set by migrateBlotterStateToPanelParams after legacy blotter state has been copied into panel params. */
  blotterStatePanelMigrationVersion: undefined as number | undefined,
  /** Set by migrateCareOrdersBlotterStateToPanelParams after legacy care orders blotter state is copied into panel params. */
  careOrdersBlotterStatePanelMigrationVersion: undefined as number | undefined,
  /** Set by migrateCareOrdersPanelToTabs after care orders panel params have been migrated to tabbed params. */
  careOrdersPanelMigrationVersion: undefined as number | undefined,
};

export type AppConfigState = typeof DEFAULT_APP_CONFIG;
